module.exports = __webpack_public_path__ + "media/images/products/ob22/ob22-1-400x400-9620c9a070c36652cc2ec17d4c8f4016.png";